import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './modules/core/core.module';
import { SharedModule } from './modules/shared/shared.module';
import localeEl from '@angular/common/locales/el';
import { registerLocaleData } from '@angular/common';
import { environment } from '../environments/environment';

registerLocaleData(localeEl);

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    CoreModule,
    SharedModule,
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'el' },
    {
      provide: 'appName',
      useValue: environment.appTitle,
    },
    {
      provide: 'apiUrl',
      useValue: environment.apiUrl,
    },
    {
      provide: 'apiAppVersion',
      useValue: environment.appVersion,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
